import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconsModule } from '@progress/kendo-angular-icons';
import { FormFieldModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DocumentsComponent } from './documents.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';

@NgModule({
  declarations: [DocumentsComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    IconsModule,
    TextBoxModule,
    LabelModule,
    GridModule,
    ButtonsModule,
    FormFieldModule,
    ReactiveFormsModule,
    IndicatorsModule,
    DropDownsModule,
    FormsModule,
    DialogsModule
  ],
  exports: [DocumentsComponent],
})
export class DocumentsModule {}
